<template>
    <div class="relative">
        <div v-if="!comments || comments.length === 0">
            <div class="bg-gray-50 p-6 mt-4">
                <UiComponentTypography variant="subtitle" class-name="text-center">
                    تا کنون نظری برای این محصول ثبت نشده است، اولین نفری باشید که نظر خود را برای ما ارسال میکنید.
                </UiComponentTypography>
            </div>
        </div>
        <div v-else>
            <ul :class="openFullComments ? '' : 'max-h-screen lg:max-h-[50vh] overflow-hidden'">
                <li v-for="(item, index) in comments"
                    class="border rounded shadow-md shadow-gray-100 mt-6 p-2 max-lg:pt-4 lg:p-4">
                    <PagesProductCommentsItem :comment="item" :index="index"
                        @replyComment="emits('replyComment', index)" />
                </li>
            </ul>
            <div v-if="comments.length > 3 && !openFullComments"
                class="absolute bottom-0 left-0 w-full border-b bg-gradient-to-t from-white via-white to-transparent min-h-48 flex items-center justify-center">
                <div class="flex h-full w-full justify-center pt-24 items-end">
                    <UButton size="md" variant="soft" icon="i-solar-add-circle-line-duotone"
                        @click="openFullComments = true">
                        مشاهده همه
                    </UButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { IComment } from "~/libs/types/api/comments";

const props = defineProps({
    comments: Array as PropType<IComment[]>,
});

const emits = defineEmits(["replyComment"]);

const { width } = useWindowSize();

const isDesktop = computed(() => {
    return width.value > 1024;
});

const openFullComments = ref(false);

</script>

<style></style>
